import { ref, computed } from 'vue';
import { defineStore, storeToRefs } from 'pinia';
import { useAuthStore } from "@/stores/auth";
import { formatarParaCarrossel } from "@/helpers/formatter";
import MenusCustomizadosService from "@/services/MenusCustomizadosService";

export const useMenusCustomizadosStore = defineStore('menusCustomizados', () => {
    // MENU
    const allMenusCustomizados = ref([]);

    const menusCustomizadosTratados = computed(() => {
        const itens = [];

        allMenusCustomizados.value.forEach(menu => {
            if (hasPersonaMenuCustomizado(menu)) {
                itens.push(formatarParaCarrossel(
                    menu.descricao,
                    menu.icone,
                    () => window.open(menu.link, '_blank')
                ));
            }
        });

        return itens;
    });

    const ultimaVezCarregadoEm = ref(null);
    const tempoExpiracaoCache = 60 * 60 * 1000; // 1 hora

    // LOADING
    const loading = ref(false);

    // ERRO
    const erro = ref(false);

    // AUTH STORE
    const authStore = useAuthStore();

    const { isAuthenticated, personas } = storeToRefs(authStore);
    //

    const getMenusCustomizados = async () => {
        const agora = Date.now();

        const tempoNaoExpirado = agora - ultimaVezCarregadoEm.value < tempoExpiracaoCache;

        if ((allMenusCustomizados.value && tempoNaoExpirado) || loading.value) return;

        erro.value = false;
        loading.value = true;

        try {
            const { data } = await MenusCustomizadosService.getMenus();

            allMenusCustomizados.value = data;

            ultimaVezCarregadoEm.value = agora;
        } catch (e) {
            erro.value = true;

            console.error(e);
        } finally {
            loading.value = false;
        }
    }

    function hasPersonaMenuCustomizado(menu) {
        if (!menu.personas || menu.personas.length === 0) return true;

        if (!isAuthenticated.value) return false;

        const userPersonaIds = personas.value.map(p => p.codigo);

        return menu.personas.some(personaId => userPersonaIds.includes(personaId));
    }

    return {
        menusCustomizadosTratados,
        loading,
        erro,
        getMenusCustomizados
    }
});
